/**
 * # ⛓️ CURSOR_ANCHOR:ui:search-event-handlers
 * Основные обработчики событий: DOMContentLoaded, popstate, клики на языковые вкладки, изменение типа поиска
 */

(function() {
  'use strict';

  /**
   * Получает текущий язык из глобального объекта
   */
  function getCurrentLang() {
    return window.SEARCH_LANGUAGE ? window.SEARCH_LANGUAGE.getCurrentLang() : 'en';
  }

  /**
   * Устанавливает текущий язык
   */
  function setCurrentLang(lang) {
    if (window.SEARCH_LANGUAGE) {
      window.SEARCH_LANGUAGE.setCurrentLang(lang);
    }
  }

  /**
   * Определяет язык из поискового запроса
   */
  function detectLanguageFromSearch(term) {
    return window.SEARCH_LANGUAGE ? window.SEARCH_LANGUAGE.detectLanguageFromSearch(term) : null;
  }

  /**
   * Переключает языковую вкладку
   */
  function switchLanguageTab(lang) {
    if (window.SEARCH_LANGUAGE) {
      window.SEARCH_LANGUAGE.switchLanguageTab(lang);
    }
  }

  /**
   * Обновляет тексты интерфейса
   */
  function updateInterfaceTexts(lang) {
    if (window.SEARCH_LANGUAGE) {
      window.SEARCH_LANGUAGE.updateInterfaceTexts(lang);
    }
  }

  /**
   * Переключает язык полностью
   */
  function switchLanguage(newLang, searchTerm, searchType) {
    if (window.SEARCH_LANGUAGE) {
      window.SEARCH_LANGUAGE.switchLanguage(newLang, searchTerm, searchType);
    }
  }

  /**
   * Загружает результаты поиска
   */
  function loadSearchResults(term, type) {
    if (window.SEARCH_API && window.SEARCH_API.loadSearchResults) {
      window.SEARCH_API.loadSearchResults(term, type);
    } else {
      // Если API еще не загружено, пробуем еще раз через 50мс
      setTimeout(function() {
        loadSearchResults(term, type);
      }, 50);
    }
  }

  /**
   * Загружает intro контент
   */
  function loadIntroContent(lang) {
    if (window.SEARCH_LANGUAGE) {
      window.SEARCH_LANGUAGE.loadIntroContent(lang);
    }
  }

  /**
   * Выполняет поиск
   */
  function performSearch(event) {
    if (window.SEARCH) {
      return window.SEARCH.performSearch(event);
    }
  }

  /**
   * Обновляет позицию toggle
   */
  function updateTogglePosition() {
    if (window.SEARCH_UI) {
      window.SEARCH_UI.updateTogglePosition();
    }
  }

  /**
   * Инициализирует аккордеон
   */
  function initAccordion() {
    if (window.SEARCH_UI) {
      window.SEARCH_UI.initAccordion();
    }
  }

  /**
   * Инициализирует обработчики названий словарей
   */
  function initDictNameHandlers() {
    if (window.SEARCH_UI) {
      window.SEARCH_UI.initDictNameHandlers();
    }
  }

  /**
   * Обработчик изменения типа поиска (новая кнопка-переключатель)
   */
  function initSearchTypeHandlers() {
    var searchModeToggle = document.getElementById('search-mode-toggle');
    var searchTypeHidden = document.getElementById('search-type-hidden');
    
    if (searchModeToggle && searchTypeHidden) {
      searchModeToggle.addEventListener('click', function() {
        // Переключаем режим: smart <-> classical
        var currentMode = this.getAttribute('data-mode');
        var newMode = (currentMode === 'smart') ? 'classical' : 'smart';
        
        // Обновляем атрибуты кнопки
        this.setAttribute('data-mode', newMode);
        searchTypeHidden.value = newMode;
        
        // Обновляем класс active для визуального состояния
        if (newMode === 'smart') {
          this.classList.add('active');
        } else {
          this.classList.remove('active');
        }
        
        // Обновляем текст кнопки (фиксированное значение)
        var label = this.querySelector('.search-mode-label');
        if (label) {
          label.textContent = '+AI';
        }
        
        // Обновляем title для подсказки
        var currentLang = getCurrentLang();
        var texts = (typeof LANG_TEXTS !== 'undefined') ? LANG_TEXTS[currentLang] : null;
        if (texts) {
          this.title = (newMode === 'smart') ? (texts.search_type_smart_desc || 'Smart') : (texts.search_type_classical_desc || 'Classical');
        } else {
          this.title = (newMode === 'smart') ? 'Smart' : 'Classical';
        }
        
        // Сохраняем режим поиска в cookies
        if (window.SEARCH_UTILS && window.SEARCH_UTILS.saveSearchType) {
          window.SEARCH_UTILS.saveSearchType(newMode);
        }
        
        var currentLang = getCurrentLang();
        var searchTerm = document.getElementById('search').value.trim();
        if (searchTerm) {
          // Проверяем язык и переключаем при необходимости
          var detectedLang = detectLanguageFromSearch(searchTerm);
          if (detectedLang !== null && detectedLang !== currentLang) {
            setCurrentLang(detectedLang);
            switchLanguageTab(detectedLang);
            // Обновляем тексты интерфейса под новый язык
            updateInterfaceTexts(detectedLang);
            // Обновляем URL на новый язык
            var queryString = 'search=' + encodeURIComponent(searchTerm) + '&search-type=' + encodeURIComponent(newMode);
            
            // Сохраняем параметр debug если он есть
            var currentParams = new URLSearchParams(window.location.search);
            if (currentParams.has('debug')) {
              queryString += '&debug=' + encodeURIComponent(currentParams.get('debug'));
            }
            var newUrl = '/' + detectedLang + '/?' + queryString;
            window.history.pushState({search: searchTerm, type: newMode, lang: detectedLang}, '', newUrl);
            // Загружаем результаты для нового языка
            loadSearchResults(searchTerm, newMode);
          } else {
            // Язык не изменился, просто выполняем поиск
            performSearch(null);
          }
        }
      });
    }
  }

  /**
   * Обработчик навигации назад/вперед браузера
   */
  function initPopstateHandler() {
    window.addEventListener('popstate', function(event) {
      // Определяем язык из нового URL
      var pathLang = window.location.pathname.split('/')[1];
      if (['en', 'ru', 'de', 'fr'].includes(pathLang)) {
        setCurrentLang(pathLang);
        switchLanguageTab(pathLang);
        updateInterfaceTexts(pathLang);
        // Обновляем border-radius формы поиска после переключения языка
        if (window.updateSearchFormBorderRadius) {
          window.updateSearchFormBorderRadius();
        }
      }
      
      var urlParams = new URLSearchParams(window.location.search);
      var searchTerm = urlParams.get('search');
      var searchType = urlParams.get('search-type') || urlParams.get('type') || '';

      // Restore history context from ?hid= parameter
      var hid = urlParams.get('hid');
      if (hid && window.getHistoryById) {
        var hidRecord = window.getHistoryById(hid);
        if (hidRecord) {
          window.CURRENT_HISTORY_ID = hid;
          // Restore PENDING_TERM for auto-expand
          if (hidRecord.termGuid) {
            window.PENDING_TERM_GUID = hidRecord.termGuid;
            window.PENDING_TERM_INDEX = null;
          } else if (hidRecord.termIndex) {
            window.PENDING_TERM_GUID = null;
            window.PENDING_TERM_INDEX = hidRecord.termIndex;
          }
          // Clear PENDING_PARENT — Back/Forward is navigation,
          // not creation of a new chain link.
          window.PENDING_PARENT_ID = null;
          window.PENDING_PARENT_TS = 0;
          // Sync chain panel
          if (window.CHAIN_PANEL && window.CHAIN_PANEL.update) {
            window.CHAIN_PANEL.update(hid);
          }
        }
      } else {
        window.CURRENT_HISTORY_ID = null;
        if (window.CHAIN_PANEL && window.CHAIN_PANEL.update) {
          window.CHAIN_PANEL.update(null);
        }
      }
      
      // Миграция и валидация типа поиска
      if (!searchType || searchType === 'exact' || searchType === 'broad' || 
          searchType === 'description' || searchType === 'broad-without-vector' || 
          searchType === '') {
        searchType = 'classical';
      } else if (searchType === 'broad-with-vector') {
        searchType = 'smart';
      }
      
      // Обновляем поле поиска
      document.getElementById('search').value = searchTerm || '';
      
      // Устанавливаем правильный режим в скрытом поле и на кнопке
      var searchModeToggle = document.getElementById('search-mode-toggle');
      var searchTypeHidden = document.getElementById('search-type-hidden');
      if (searchModeToggle && searchTypeHidden) {
        searchTypeHidden.value = searchType;
        searchModeToggle.setAttribute('data-mode', searchType);
        if (searchType === 'smart') {
          searchModeToggle.classList.add('active');
        } else {
          searchModeToggle.classList.remove('active');
        }
        
        // Обновляем title для подсказки
        var currentLang = getCurrentLang();
        var texts = (typeof LANG_TEXTS !== 'undefined') ? LANG_TEXTS[currentLang] : null;
        if (texts) {
          searchModeToggle.title = (searchType === 'smart') ? (texts.search_type_smart_desc || 'Smart') : (texts.search_type_classical_desc || 'Classical');
        } else {
          searchModeToggle.title = (searchType === 'smart') ? 'Smart' : 'Classical';
        }
      }
      
      // Проверяем наличие хэша в URL для скролла к термину (guid или legacy #term-N)
      var hash = window.location.hash;
      var hasTermHash = hash && (hash.indexOf('#term-') === 0 || (hash.length > 1 && hash.indexOf(':') > 1));
      
      if (searchTerm) {
        loadSearchResults(searchTerm, searchType);
        
        // Плавный скролл после загрузки результатов
        if (hasTermHash) {
          // Если есть хэш термина, используем существующую функцию для плавного скролла
          // Увеличиваем задержку, чтобы результаты успели загрузиться и отрендериться
          // Используем несколько попыток с увеличивающейся задержкой
          var scrollAttempts = 0;
          var maxScrollAttempts = 5;
          var tryScroll = function() {
            scrollAttempts++;
            var results = document.querySelectorAll('.opredelenie');
            if (results.length > 0) {
              // Результаты загружены, вызываем скролл
              if (window.SEARCH_UI && window.SEARCH_UI.expandTermFromHash) {
                window.SEARCH_UI.expandTermFromHash();
              } else if (window.expandTermFromHash) {
                window.expandTermFromHash();
              }
            } else if (scrollAttempts < maxScrollAttempts) {
              // Результаты еще не загружены, пробуем еще раз
              setTimeout(tryScroll, 300);
            }
          };
          setTimeout(tryScroll, 600);
        } else {
          // Если хэша нет, плавно прокручиваем вверх (используем jQuery для совместимости)
          setTimeout(function() {
            if (typeof $ !== 'undefined') {
              $('html, body').stop().animate({ scrollTop: 0 }, 400);
            } else {
              window.scrollTo({ top: 0, behavior: 'smooth' });
            }
          }, 100);
        }
      } else {
        // Загружаем intro контент для текущего языка
        loadIntroContent(getCurrentLang());
        
        // Плавно прокручиваем вверх при переходе на intro (используем jQuery для совместимости)
        setTimeout(function() {
          if (typeof $ !== 'undefined') {
            $('html, body').stop().animate({ scrollTop: 0 }, 400);
          } else {
            window.scrollTo({ top: 0, behavior: 'smooth' });
          }
        }, 100);
      }
    });
  }

  /**
   * Обработчики клика на языковые вкладки
   */
  function initLanguageTabHandlers() {
    var langLinks = document.querySelectorAll('#langs a:not(.langs-book-icon)');
    langLinks.forEach(function(link) {
      link.addEventListener('click', function(e) {
        // Если мы на странице гайда, не используем AJAX переключение, 
        // позволяем браузеру просто перейти по ссылке
        if (document.body.classList.contains('guide-page')) {
          return;
        }

        e.preventDefault();
        
        // Извлекаем язык из href (формат: /ru/, /en/, /de/, /fr/)
        var href = link.getAttribute('href');
        var hrefMatch = href.match(/\/(ru|en|de|fr)\//);
        if (!hrefMatch) {
          return false; // Неверный формат href
        }
        var newLang = hrefMatch[1];
        
        // Если язык не изменился, ничего не делаем
        if (newLang === getCurrentLang()) {
          return false;
        }
        
        // Получаем текущие параметры поиска
        // ВАЖНО: при клике на языковую вкладку берем ТОЛЬКО из поля поиска
        // Если поле пустое - явно передаем пустую строку для показа intro контента
        var searchInput = document.getElementById('search');
        var searchTerm = searchInput ? searchInput.value.trim() : '';
        // Если поле пустое, явно устанавливаем пустую строку (не берем из URL)
        if (!searchTerm || searchTerm.length === 0) {
          searchTerm = '';
        }
        
        // Получаем выбранный тип поиска из radio buttons
        var searchTypeRadios = document.querySelectorAll('input[name="search-type"]:checked');
        var searchType = '';
        if (searchTypeRadios.length > 0) {
          searchType = searchTypeRadios[0].value;
        }
        // Если не выбран, берем из URL
        if (!searchType) {
          var urlParams = new URLSearchParams(window.location.search);
          searchType = urlParams.get('search-type') || urlParams.get('type') || '';
        }
        
        // Переключаем язык без перезагрузки страницы
        switchLanguage(newLang, searchTerm, searchType);
        
        // Обновляем border-radius формы поиска после переключения языка
        if (window.updateSearchFormBorderRadius) {
          window.updateSearchFormBorderRadius();
        }
        
        return false;
      });
    });
  }

  /**
   * Восстанавливает язык из cookies при загрузке страницы
   */
  function restoreLanguageFromCookies() {
    // Если мы на странице гайда, не восстанавливаем язык из cookies автоматически,
    // чтобы не перебивать явный выбор языка в URL (/ru/guide/ и т.д.)
    if (document.body.classList.contains('guide-page')) {
      return;
    }

    if (window.SEARCH_UTILS && window.SEARCH_UTILS.getSavedLanguage) {
      var savedLang = window.SEARCH_UTILS.getSavedLanguage();
      if (savedLang && ['en', 'ru', 'de', 'fr'].includes(savedLang)) {
        // Определяем язык из URL
        var pathLang = window.location.pathname.split('/')[1];
        var urlLang = ['en', 'ru', 'de', 'fr'].includes(pathLang) ? pathLang : null;
        
        // Проверяем наличие параметра search в URL
        var urlParams = new URLSearchParams(window.location.search);
        var hasSearchParam = urlParams.has('search') && urlParams.get('search');
        
        // Если в URL есть язык И есть параметр search - язык из URL имеет приоритет
        // НЕ переключаемся на язык из cookies
        if (hasSearchParam && urlLang) {
          // Язык из URL имеет приоритет, просто обновляем состояние
          if (window.SEARCH_LANGUAGE) {
            window.SEARCH_LANGUAGE.setCurrentLang(urlLang);
            window.SEARCH_LANGUAGE.switchLanguageTab(urlLang);
          }
        } else if (urlLang && savedLang !== urlLang) {
          // Если в URL есть язык, но нет search параметра, и сохраненный язык отличается
          // переключаемся на сохраненный язык из cookies
          var searchTerm = urlParams.get('search') || '';
          var searchType = urlParams.get('search-type') || urlParams.get('type') || '';
          
          // Переключаем язык без перезагрузки страницы
          if (window.SEARCH_LANGUAGE && window.SEARCH_LANGUAGE.switchLanguage) {
            window.SEARCH_LANGUAGE.switchLanguage(savedLang, searchTerm, searchType);
          }
        } else if (!urlLang && savedLang) {
          // Если в URL нет языка - используем язык из cookies
          var searchTerm = urlParams.get('search') || '';
          var searchType = urlParams.get('search-type') || urlParams.get('type') || '';
          
          // Переключаем язык без перезагрузки страницы
          if (window.SEARCH_LANGUAGE && window.SEARCH_LANGUAGE.switchLanguage) {
            window.SEARCH_LANGUAGE.switchLanguage(savedLang, searchTerm, searchType);
          }
        } else {
          // Язык совпадает, просто обновляем состояние
          var finalLang = urlLang || savedLang || 'en';
          if (window.SEARCH_LANGUAGE) {
            window.SEARCH_LANGUAGE.setCurrentLang(finalLang);
            window.SEARCH_LANGUAGE.switchLanguageTab(finalLang);
          }
        }
      }
    }
  }

  /**
   * Автоматический запуск поиска при загрузке страницы, если есть параметр search=
   */
  function autoSearchOnLoad() {
    var urlParams = new URLSearchParams(window.location.search);
    var searchParam = urlParams.get('search');
    var searchType = urlParams.get('search-type') || urlParams.get('type') || '';
    
    // Если типа нет в URL, пробуем из cookies
    if (!searchType && window.SEARCH_UTILS && window.SEARCH_UTILS.getSavedSearchType) {
      searchType = window.SEARCH_UTILS.getSavedSearchType();
    }
    
    // Миграция и валидация типа поиска
    if (!searchType || searchType === 'exact' || searchType === 'broad' || 
        searchType === 'description' || searchType === 'broad-without-vector' || 
        searchType === '') {
      searchType = 'classical';
    } else if (searchType === 'broad-with-vector') {
      searchType = 'smart';
    }
    
    // Устанавливаем правильный режим в скрытом поле и на кнопке
    var searchModeToggle = document.getElementById('search-mode-toggle');
    var searchTypeHidden = document.getElementById('search-type-hidden');
    if (searchModeToggle && searchTypeHidden) {
      searchTypeHidden.value = searchType;
      searchModeToggle.setAttribute('data-mode', searchType);
      if (searchType === 'smart') {
        searchModeToggle.classList.add('active');
      } else {
        searchModeToggle.classList.remove('active');
      }
    }
    
    if (searchParam) {
      // Устанавливаем значение в поле поиска
      var searchInput = document.getElementById('search');
      if (searchInput) {
        searchInput.value = searchParam;
      }
      
      // Запускаем поиск через AJAX
      loadSearchResults(searchParam, searchType);
    }
  }

  /**
   * Умная установка фокуса в поле поиска
   * Не фокусирует на мобильных устройствах, чтобы не всплывала клавиатура,
   * и если в URL уже есть поисковый запрос (приоритет результатам)
   */
  function smartFocus() {
    var isMobile = window.SEARCH_UTILS && window.SEARCH_UTILS.isMobileDevice && window.SEARCH_UTILS.isMobileDevice();
    if (isMobile) {
      return; // На мобильных никогда не фокусируем автоматически
    }

    var urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('search') && urlParams.get('search')) {
      return; // Если есть поиск, не фокусируем (пользователь хочет видеть результаты)
    }

    var searchInput = document.getElementById('search');
    if (searchInput) {
      searchInput.focus();
    }
  }

  /**
   * Инициализация при загрузке DOM
   */
  function init() {
    // Инициализируем историю поиска
    if (window.SEARCH_HISTORY && window.SEARCH_HISTORY.initSearchHistory) {
      window.SEARCH_HISTORY.initSearchHistory();
    }
    
    // Восстанавливаем сохраненный режим поиска перед обновлением toggle position
    if (window.SEARCH_UTILS && window.SEARCH_UTILS.restoreSearchType) {
      window.SEARCH_UTILS.restoreSearchType();
    }
    
    // Инициализируем позицию toggle при загрузке
    updateTogglePosition();
    
    // Обновляем border-radius формы поиска при загрузке
    requestAnimationFrame(function() {
      if (window.updateSearchFormBorderRadius) {
        window.updateSearchFormBorderRadius();
      }
    });
    
    // Инициализируем обработчики
    initSearchTypeHandlers();
    initPopstateHandler();
    initLanguageTabHandlers();
    
    // Инициализация при загрузке страницы
    initAccordion();
    initDictNameHandlers();
    
    // Восстанавливаем язык из cookie при загрузке страницы
    restoreLanguageFromCookies();
    
    // Обновляем позицию toggle при загрузке
    updateTogglePosition();
    
    // Автоматический запуск поиска при загрузке страницы, если есть параметр search=
    autoSearchOnLoad();

    // Умная установка фокуса (только для десктопа и пустой страницы)
    smartFocus();
    
    // Инициализируем кастомные тултипы
    if (window.SEARCH_UTILS && window.SEARCH_UTILS.initCustomTooltips) {
      window.SEARCH_UTILS.initCustomTooltips();
    }
    
    // Обновляем border-radius формы поиска в конце обработчика DOMContentLoaded
    setTimeout(function() {
      if (window.updateSearchFormBorderRadius) {
        window.updateSearchFormBorderRadius();
      }
    }, 0);
  }

  // Инициализируем при загрузке DOM
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();



